import { Injectable } from '@angular/core';
import { HttpService } from '@app/core/services/http/http.service';
import {
	RelationTypeChangeSequenceModel,
	RelationTypeCreateModel,
	RelationTypeTableItemModel,
	RelationTypeUpdateModel,
} from '@app/modules/relation-type/models';
import { TableDataModel } from '@app/shared/models';
import { KeyValueModel } from '@app/shared/models/common/key-value.model';
import { TablePaginationModel } from '@app/shared/models/table/table-pagination.model';
import { TableSortingModel } from '@app/shared/models/table/table-sorting.model';
import { parse } from '@app/shared/utilities/url-search-params-parser';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class RelationTypeService {
	private readonly endpoints = {
		get: 'RelationType/:id',
		overview: 'RelationType/GetOverview',
		update: 'RelationType/Update',
		create: 'RelationType/Create',
		delete: 'RelationType/Delete?id=:id',
		changeSequence: 'RelationType/ChangeSequence',
		getAll: 'RelationType/GetAll'
	};

	constructor(private readonly httpService: HttpService) {}

	getOverview(
		sorting: TableSortingModel,
		pagination: TablePaginationModel
	): Observable<TableDataModel<RelationTypeTableItemModel>> {
		const paginationParams = parse(pagination, 'pagination');
		const sortingParams = parse(sorting, 'sorting');

		return this.httpService.get<any>(this.endpoints.overview + `?${paginationParams}&${sortingParams}`);
	}

	get(id: number): Observable<RelationTypeUpdateModel> {
		return this.httpService.get<any>(this.endpoints.get.replace(':id', id.toString()));
	}

	update(request: RelationTypeUpdateModel): Observable<RelationTypeUpdateModel> {
		return this.httpService.put<any>(this.endpoints.update, request);
	}

	create(request: RelationTypeCreateModel): Observable<RelationTypeUpdateModel> {
		return this.httpService.post<any>(this.endpoints.create, request);
	}

	delete(id: number): Observable<any> {
		return this.httpService.delete<any>(this.endpoints.delete.replace(':id', id.toString()));
	}

	changeSequence(request: RelationTypeChangeSequenceModel): Observable<any> {
		return this.httpService.put<any>(this.endpoints.changeSequence, request);
	}

	getAll(): Observable<KeyValueModel[]> {
		return this.httpService.get<KeyValueModel[]>(this.endpoints.getAll);
	}
}
